module.exports = __webpack_public_path__ + "static/guillaumepotier-8ce51a3514676e8ce37411c35591d155.png";